import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import ExpiredPasswordPanelActions from './actions';

const initialState = Immutable({
  email: '',
});

export default createReducer(on => {
  on(ExpiredPasswordPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
